import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';

export interface Props {
  title: { index: number; content: string } | string;
}

const Title = styled('span')(({ theme: { palette } }) => ({
  display: 'inline-block',
  position: 'relative',
  '&::after': {
    content: '""',
    height: 1,

    display: 'inline-block',
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  '&.gradient1': {
    '&::after': { background: palette.brand.gradient.violetBlue },
  },
  '&.gradient2': {
    '&::after': { background: palette.brand.gradient.pinkViolet },
  },
}));

const GRADIENT_CLASSNAMES = ['gradient1', 'gradient2'];

export default function HeaderDropDownOverTitle({ title }: Props) {
  const { index, content: titleStr } =
    typeof title === 'string' ? { index: 0, content: title } : title;

  return (
    <Typography
      variant="bodySmall"
      component={Title}
      className={GRADIENT_CLASSNAMES[index % 2]}
      sx={{ ml: 2 }}
    >
      {titleStr}
    </Typography>
  );
}
